import { Injectable } from '@angular/core';

import { AppState } from '../app-state';
import { PathTestDoc } from '../schema/path-test-schema';
import { ScoutTaskDoc } from '../schema/scout-task-schema';
import { PathTestService } from './path-test.service';
import { ScoutTaskService } from './scout-task.service';
import { TestbedCollectionService } from './testbed-rxdb/testbed-collection.service';


@Injectable({ providedIn: 'root' })
export class TaskService extends TestbedCollectionService<ScoutTaskDoc|PathTestDoc> {

    constructor( 
        public scoutTaskService: ScoutTaskService,
        public pathTestService: PathTestService,
        appState : AppState ) {
              super(appState)        
    }

    async getById( id: string ) {
        return (await this.scoutTaskService.getById(id)) || (await this.pathTestService.getById(id))
    }
}